import InPageNavContent from './content';
export default InPageNavContent;
